export const ReportDefault = {
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신시켜주세요.'
        }
    }
}